export function useCustomer() {
  function getCustomer(): Record<string, unknown> | null {
    const data = localStorage.getItem('mage-cache-storage');

    if (!data) {
      return null;
    }

    return JSON.parse(data).customer;
  }

  function getBearerToken(): string | undefined {
    return getCustomer()?.signin_token as string | undefined;
  }

  return {
    getCustomer,
    getBearerToken,
  };
}
